import React from 'react';
import './ImageGallery.css';

const imageUrls = [
  'https://i.postimg.cc/bvNZQstV/Whats-App-Image-2025-06-07-at-20-45-21-6e4d3595.jpg',
  'https://i.postimg.cc/CKHSVqmv/IMG-20250530-WA0052.jpg',
  'https://i.postimg.cc/j2CbNkK9/IMG-20250530-WA0053.jpg',
  'https://i.postimg.cc/htmKpwxR/IMG-20250530-WA0054.jpg',
  'https://i.postimg.cc/65mQHnmn/IMG-20250530-WA0055.jpg',
  'https://i.postimg.cc/cH01Kmvy/IMG-20250530-WA0056.jpg',
  'https://i.postimg.cc/9Mh0d2Nk/IMG-20250530-WA0057.jpg',
  'https://i.postimg.cc/MpfpgHC4/IMG-20250530-WA0058.jpg',
  'https://i.postimg.cc/fLCzY9d3/IMG-20250530-WA0059.jpg',
];

const ImageGallery = () => {
  return (
    <section className="image-gallery-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <h2 className="text-center mb-5" style={{ fontWeight: 700 }}>छायाचित्र झलक</h2>
        <div className="gallery-grid">
          {imageUrls.map((url, index) => (
            <div key={index} className="gallery-item">
              <img src={url} alt={`Gallery ${index}`} className="gallery-img" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;
